import LocalizedStrings from 'react-localization';
let lang = new LocalizedStrings({
    en: {
        carLoan: "Car Loan Calculator",
        cacheLoan: "Cash Loan Calculator",
        mortgageLoan: "Mortgage Loan Calculator",
        calculationResult:"Calculation Result",
        monthlyInstallment:"Monthly Installment:",
    },
    ar: {
        carLoan: "حاسبة قرض السيارة",
        cacheLoan: "حاسبة القرض النقدي",
        mortgageLoan: "حاسبة قرض الرهن العقاري",
        calculationResult:"نتيجة الحساب",
        monthlyInstallment:"القسط الشهري:"
    }
});

export default lang;